<template>
	<div>
        <div class="btn-box">
            <el-radio-group size='mini' @change='typeChange' v-model="typeRadio">
                <el-radio-button label="1">已绑定</el-radio-button>
                <el-radio-button label="2">未绑定</el-radio-button>
            </el-radio-group>
        </div>
		<div class="filters-box-row">
			<div class="name-box">
				<span>店铺名称:</span>
				<el-input
					v-model="shopName"
					placeholder='请输入店铺名称或者店铺编号'
					class="name-input"
					size="mini"
					@keyup.enter.native="searchClick"
					></el-input>
				<el-button
					type="primary"
					class="search-btn"
					size="mini"
                    plain
					@click="searchClick">查询</el-button>
			</div>
		</div>
		<div class="bind-body">
			<div class="grid-container">
				<el-table
					:stripe='true'
					class="grid-content"
					ref="multipleTable"
					:data="tableData"
					:height="tableHeight"
                    size='mini'
                    v-loadmore="loadMore"
                    @selection-change="handleSelectionChange"
					border>
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55">
                    </el-table-column>
					<el-table-column
						label="序号"
						type="index"
						width="70"
						align="center">
					</el-table-column>
                    <el-table-column
						label="店铺名称"
						prop='shopName'
						min-width="180"
						align="center">
						<!-- <template slot-scope="scope">
							<span v-if='scope.row.registname'>{{scope.row.registname}}</span>
							<span v-else>个人</span>
						</template> -->
					</el-table-column>
                    <el-table-column
						label="店铺编号"
						prop='shopCode'
						min-width="180"
						align="center">
					</el-table-column>
				</el-table>
			</div>
		</div>
        <div>
            <el-button v-show="showBtn" v-if='typeRadio === "2"' :disabled="isDisable" plain style="width:100%;margin-top:15px" size='small' type="primary" @click="bindClick">绑定</el-button>
			<el-button v-show="showBtn" v-else :disabled="isDisable" plain style="width:100%;margin-top:15px" size='small' type="primary" @click="unBindClick">解绑</el-button>
        </div>
	</div>
</template>

<script>
export default {
	name: 'bind',
	props: {
		isShow: Boolean,
		modifyData: Object,
		id: String,
		isAdd: Boolean,
		// addDisable: Boolean,
		isDisabled: Boolean
	},
	// props: {
	// 	isShow: Boolean,
	// 	customerid: String
	// },
	data () {
		return {
			editDisable: false,
			addDisable: false,
			showBtn: false,
			staffid: '',
			checkArr: [],
			number: 1,
			isLoad: true,
			isDisable: true,
			syscode: '',
			shopName: '',
			typeRadio: '1',
			tableData: [],
			tableHeight: 250,
			name: ''
		}
	},
	created () {
		this.getAuthority('01_0004_0000_00')
	},
	watch: {
		modifyData: {
			handler (data) {
				if (data === null) {
					if (this.id) {
						this.staffid = this.id
					}
				} else {
					this.staffid = data.staffid
				}
			},
			immediate: true
		},
		isShow: {
			handler (val) {
				if (val) {
					if (this.staffid !== '') {
						this.number = 1
						this.reloadBind()
					}
				}
			},
			immediate: true
		}
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						if (a[i] === '01_0004_0001_00') {
							this.editDisable = true
						} else if (a[i] === '01_0004_0002_00') {
							this.addDisable = true
						}
					}
					if (this.isAdd) {
						this.showBtn = true
					} else {
						if (this.editDisable === true) {
							this.showBtn = true
						} else {
							this.showBtn = false
						}
					}
				}
			})
		},
		toggleSelection (arr) {
			let toggArr = []
			let tempData = arr
			if (tempData !== null && tempData.length > 0) {
				for (let i = 0; i < tempData.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (tempData[i].id === this.tableData[j].id) {
							toggArr.push(this.tableData[j])
						}
					}
				}
			}
			if (toggArr) {
				toggArr.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection()
			}
		},
		toggleSelection1 (arr) {
			let toggArr = []
			let tempData = arr
			if (tempData !== null && tempData.length > 0) {
				for (let i = 0; i < tempData.length; i++) {
					for (let j = 0; j < this.tableData.length; j++) {
						if (tempData[i].shopId === this.tableData[j].shopId) {
							toggArr.push(this.tableData[j])
						}
					}
				}
			}
			if (toggArr) {
				toggArr.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row)
				})
			} else {
				this.$refs.multipleTable.clearSelection()
			}
		},
		bindClick () {
			let a = this.checkArr
			let arr = []
			for (let i = 0; i < a.length; i++) {
				arr.push(a[i].shopId)
			}
			let params = {
				shopIds: arr,
				staffid: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/addRelatedUserShop`,
				data: params
			}).then(res => {
				if (res.resultFlag === true) {
					this.number = 1
					this.isLoad = true
					this.checkArr = []
					this.tableData = []
					this.reloadUnBind()
					this.$message.success('绑定成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		unBindClick () {
			let a = this.checkArr
			let arr = []
			for (let i = 0; i < a.length; i++) {
				arr.push(a[i].id)
			}
			let params = {
				relatedIds: arr
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/delRelatedShopUser`,
				data: params
			}).then(res => {
				if (res.resultFlag === true) {
					this.number = 1
					this.isLoad = true
					this.checkArr = []
					this.tableData = []
					this.reloadBind()
					this.$message.success('解绑成功')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		reloadBind () {
			let arr = this.checkArr
			let params = {
				size: 100,
				page: this.number,
				staffid: this.staffid,
				keyword: this.shopName,
				usertype: -1

			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/getShopByUser`,
				data: params
			}).then(res => {
				if (res.result === true) {
					if (res.data.recordList) {
						this.tableData = this.tableData.concat(...res.data.recordList)
						this.$nextTick(function () {
							if (arr.length > 0) {
								this.toggleSelection(arr)
							}
						})
						if (res.data.recordList.length < 100) {
							this.isLoad = false
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		reloadUnBind () {
			let arr = this.checkArr
			let params = {
				size: 100,
				page: this.number,
				staffid: this.staffid,
				keyword: this.shopName,
				usertype: -1
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/addShopByUser`,
				data: params
			}).then(res => {
				if (res.result === true) {
					if (res.data) {
						this.tableData = this.tableData.concat(...res.data)
						this.$nextTick(function () {
							if (arr.length > 0) {
								this.toggleSelection1(arr)
							}
						})
						if (res.data.length < 100) {
							this.isLoad = false
						}
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		typeChange () {
			this.number = 1
			this.isLoad = true
			this.shopName = ''
			this.syscode = ''
			this.tableData = []
			this.checkArr = []
			if (this.typeRadio === '1') {
				this.reloadBind()
			} else {
				this.reloadUnBind()
			}
		},
		handleSelectionChange (data) {
			this.checkArr = data
			if (data.length > 0) {
				this.isDisable = false
			} else {
				this.isDisable = true
			}
		},
		loadMore () {
			if (this.isLoad === true) {
				this.number++
				if (this.typeRadio === '1') {
					this.reloadBind()
				} else {
					this.reloadUnBind()
				}
			} else {
				return false
			}
		},
		searchClick () {
			this.checkArr = []
			this.tableData = []
			if (this.typeRadio === '1') {
				this.reloadBind()
			} else {
				this.reloadUnBind()
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.btn-box{
        margin-bottom:10px;
        margin-top:10px;
        text-align :left;
    }
.filters-box-row {
	display: flex;
    text-align :left;
	padding-bottom: 20px;
	.name-box {
		.name-input {
			width: 200px;
			margin-left: 10px;
            margin-right :10px;
		};
		.search-btn {
			height: 31px;
			margin-left: 30px;
		}
	}
}
</style>
